import { render, staticRenderFns } from "./updateAbnormal.vue?vue&type=template&id=2f6a25f0&scoped=true"
import script from "./updateAbnormal.vue?vue&type=script&lang=js"
export * from "./updateAbnormal.vue?vue&type=script&lang=js"
import style0 from "./updateAbnormal.vue?vue&type=style&index=0&id=2f6a25f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6a25f0",
  null
  
)

export default component.exports